
import { history } from './history';

function redirectUser(user) {
    history.push('/landing');
}
export default redirectUser;



// WEBPACK FOOTER //
// ./src/_helpers/user-homepage.js